import i18next from 'i18next';
import Backend from 'i18next-http-backend';
import LanguageDetector from 'i18next-browser-languagedetector';
import { initReactI18next } from 'react-i18next';

i18next
  .use(initReactI18next)
  .use(Backend)
  .use(LanguageDetector)
  .init({
    fallbackLng: 'en',
    load: 'languageOnly',
    // debug: true,
    detection: {
      order: ['querystring', 'cookie', 'navigator'],
      caches: ['cookie'],
      lookupQuerystring: 'lang',
      excludeCacheFor: ['cimode'],
    },
    interpolation: {
      escapeValue: false,
    },
    backend: {
      loadPath: '/api/translations/cabinet/{{lng}}',
    },

  });
export default i18next;
